/** 権限: 一般権限 — ordinary clinic user, out of scope for the SSO link. */
export const CLINIC_USER_ROLE_NORMAL = 0;

/** 権限: 管理者権限 — the single clinic administrator, the only role linked to SSO. */
export const CLINIC_USER_ROLE_ADMIN = 1;

export const CLINIC_USER_ROLE_OPTIONS = [
  { value: CLINIC_USER_ROLE_NORMAL, label: '一般権限' },
  { value: CLINIC_USER_ROLE_ADMIN, label: '管理者権限' },
];

/** Shown under the 権限 dropdown when another user of the clinic already holds 管理者権限. */
export const CLINIC_USER_ADMIN_EXISTS_MESSAGE =
  'この治療院には既に管理権限を持つユーザーが存在するため、管理権限は選択できません。';

/**
 * Shown under メールアドレス while 管理者権限 is selected.
 *
 * The address is not decoration for this role: it becomes the Cognito username the SSO link is
 * keyed on, which is why the backend turns the field `required` for 管理者権限 alone
 * (ClinicUserRoleValidation::clinicUserEmailRules). Saying so at the field means the operator
 * reads the reason before the save, instead of a bare 必須です afterwards.
 */
export const CLINIC_USER_ADMIN_EMAIL_SSO_MESSAGE =
  'SSO連携を行うため、メールアドレスが必要です。';

/** Badge shown next to the name on the clinic user list. */
export const CLINIC_USER_ADMIN_BADGE_LABEL = '管理者';
